import { Vue } from 'vue-property-decorator'
import Cup from './Cup.vue'

Vue.component('Cup', Cup)
